// src/utils/createPageUrl.js
export const routes = {
  Home: "/",
  TennisCoaching: "/tennis",
  WebDevelopment: "/web-development",
  Portfolio: "/portfolio",
};

export const createPageUrl = (pageName) => {
  return routes[pageName] || "/";
};
